import { Config } from '../../config';
import { AuthPermit } from './authPermit';

/** The app URL of the token's region when it differs from this build's region (missing claim = `us`, `any` stays). */
export function getRegionRedirectUrl(permit: AuthPermit): string | null {
  const { home, urls } = Config.region;
  const region = permit.idTokenPayload['https://clipr.ai/region'] ?? 'us';
  if (!home || region === 'any' || region === home)
    return null;
  return urls[region] ?? null;
}

export function goToRegion(url: string) {
  window.location.replace(url);
}
